import React from 'react';
import { Package, FileText, CheckSquare } from 'lucide-react';

interface CustomerSidebarProps {
  currentSection: 'angebote' | 'fragebogen' | 'aufgaben';
  onSectionChange: (section: 'angebote' | 'fragebogen' | 'aufgaben') => void;
}

const CustomerSidebar: React.FC<CustomerSidebarProps> = ({ currentSection, onSectionChange }) => {
  const sections = [
    {
      id: 'angebote' as const,
      label: 'Angebote',
      icon: Package,
      description: 'Deine Projekte'
    },
    {
      id: 'fragebogen' as const,
      label: 'Fragebogen',
      icon: FileText,
      description: 'Kick-Off Formulare'
    },
    {
      id: 'aufgaben' as const,
      label: 'Aufgaben',
      icon: CheckSquare,
      description: 'Zugewiesene Fragebögen'
    }
  ];

  return (
    <div className="fixed left-0 top-14 h-[calc(100vh-3.5rem)] w-64 bg-white border-r border-gray-200 overflow-y-auto">
      <div className="p-6">
        <h2 className="text-2xl font-bold text-gray-900 mb-2">
          Mein Dashboard
        </h2>
        <p className="text-sm text-gray-600 mb-6">
          Verwalte deine Projekte
        </p>

        <nav className="space-y-2">
          {sections.map((section) => {
            const Icon = section.icon;
            const isActive = currentSection === section.id;

            return (
              <button
                key={section.id}
                onClick={() => onSectionChange(section.id)}
                className={`w-full flex items-start gap-3 px-4 py-3 rounded-lg transition-all ${
                  isActive
                    ? 'bg-blue-50 border-2 border-blue-500 text-blue-700'
                    : 'bg-white border-2 border-gray-200 text-gray-700 hover:bg-gray-50 hover:border-gray-300'
                }`}
              >
                <Icon
                  className={`w-5 h-5 mt-0.5 flex-shrink-0 ${
                    isActive ? 'text-blue-600' : 'text-gray-500'
                  }`}
                />
                <div className="text-left">
                  <div className={`font-semibold ${isActive ? 'text-blue-700' : 'text-gray-900'}`}>
                    {section.label}
                  </div>
                  <div className={`text-xs ${isActive ? 'text-blue-600' : 'text-gray-500'}`}>
                    {section.description}
                  </div>
                </div>
              </button>
            );
          })}
        </nav>
      </div>
    </div>
  );
};

export default CustomerSidebar;

